const BaseComponent = require('base/base-component');

function getCSS (curEle, attr) {
  // curele:对象; attr：要获取的的属性
  if (window.getComputedStyle) {
    // ie9以上浏览器支持
    return window.getComputedStyle(curEle, null).getPropertyValue(attr);
  }
  return curEle.currentStyle[attr];
}

function overflowhidden (text, rows, str) {
  let lineHeight = getCSS(text, 'line-height'); // 获取到line-height样式设置的值 必须要有
  let at = rows * parseInt(lineHeight, 10); // 计算包含文本的div应该有的高度
  let tempstr = str; // 获取到所有文本
  text.innerHTML = tempstr; // 将所有文本写入html中
  let len = tempstr.length;
  let i = 0;
  if (text.offsetHeight <= at) {
    // 如果所有文本在写入html后文本没有溢出，那不需要做溢出处理
    /* text.innerHTML = tempstr; */
  } else {
    // 否则 一个一个字符添加写入 不断判断写入后是否溢出
    let temp = '';
    text.innerHTML = temp;
    while (text.offsetHeight <= at) {
      temp = tempstr.substring(0, i + 1);
      i++;
      text.innerHTML = temp;
    }
    let slen = temp.length;
    tempstr = temp.substring(0, slen - 1);
    len = tempstr.length;
    text.innerHTML = tempstr.substring(0, len - 3) + '...'; // 替换string后面三个字符
    text.height = at + 'px'; // 修改文本高度 为了让CSS样式overflow：hidden生效
  }
}
class newsCarouselBaseClass extends BaseComponent {
  init () {
    this.count = 0;
    this.$itemBox = this.$el.find('.img');
    this.$item = this.$itemBox.find('li');
    this.$btnBox = this.$el.find('.num');
    this.$btn = null;
    this.componentInit();

    $.map(this.$el.find('.img li'), (el) => {
      const $title = $(el).find('.title');
      const $remark = $(el).find('.remark');
      const lineHeight = parseInt(getCSS($title[0], 'line-height'), 10);
      if ($title[0].offsetHeight > lineHeight) {
        overflowhidden($title[0], 2, $title[0].innerHTML);
        overflowhidden($remark[0], 2, $remark[0].innerHTML);
        $title.css('visibility', 'visible');
        $remark.css('visibility', 'visible');
      } else {
        overflowhidden($title[0], 1, $title[0].innerHTML);
        overflowhidden($remark[0], 3, $remark[0].innerHTML);
        $title.css('visibility', 'visible');
        $remark.css('visibility', 'visible');
      }
    });

    const img = this.$itemBox.find('img');
    $(img[0]).attr('src',$(img[0]).attr('data-src'));
    let len=img.length;
    for (let i=0; i<len;i++) {
      setTimeout(function (j) {
        $(img[j]).attr('src',$(img[j]).attr('data-src'));
      }, 1000*i,i)
    }
  }

  componentInit () {
    if (this.$item.length <= 1) {
      return;
    }
    let that = this;
    let clone = that.$item.first().clone(); // 克隆第一张图片
    that.$itemBox.append(clone); // 复制到列表最后
    that.size = that.$item.length + 1;
    for (let j = 0; j < that.size - 1; j++) {
      that.$btnBox.append('<li></li>');
    }
    that.$btn = that.$btnBox.find('li');
    that.$btn.first().addClass('on');
    that.t = setInterval(() => {
      that.count++;
      that.move();
    }, 5000);
    that.bindEvent();

  }

  bindEvent () {
    let that = this;
    that.$btn.hover(function () {
      let index = $(this).index(); // 获取当前索引值
      that.count = index;
      that.$itemBox.stop().animate(
        {
          left: -index * 440
        },
        440
      );
      $(this)
        .addClass('on')
        .siblings()
        .removeClass('on');
    });
    this.$itemBox.on('mouseenter', () => this.stopScroll());
    this.$itemBox.on('mouseleave', () => this.continueScroll());
  }

  move () {
    let that = this;
    if (that.count == that.size) {
      that.$itemBox.css({
        left: 0
      });
      that.count = 1;
    }
    if (that.count == -1) {
      that.$itemBox.css({
        left: -(that.size - 1) * 440
      });
      that.count = that.size - 2;
    }
    that.$itemBox.stop().animate(
      {
        left: -that.count * 440
      },
      440
    );
    if (that.count == that.size - 1) {
      that.$btn
        .eq(0)
        .addClass('on')
        .siblings()
        .removeClass('on');
    } else {
      that.$btn
        .eq(that.count)
        .addClass('on')
        .siblings()
        .removeClass('on');
    }
  }
  stopScroll () {
    clearInterval(this.t); // 鼠标悬停时清除定时器
  }
  continueScroll () {
    this.t = setInterval(() => {
      this.count++;
      this.move();
    }, 5000); // 鼠标移出时重新启动定时器
  }
}

module.exports = newsCarouselBaseClass;
